// extracted by mini-css-extract-plugin
module.exports = {"container":"TermsOfUse_container__23g1D","bigTitle":"TermsOfUse_bigTitle__2NVRy","ltr":"TermsOfUse_ltr__1XWVc"};